<template>
  <div id="contratos-toolbar-contratos-ejecucion">
    <v-toolbar flat>
      <template
        v-if="regresar">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="botonRegresar">
              <v-icon>
                fa-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </template>
      <v-toolbar-title
      :class="{
        'display-1': !$vuetify.breakpoint.xs,
        'display-0': $vuetify.breakpoint.xs
        }">
        {{ titulo }}
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'TituloToolBarContratoEjecucion',
  props: {
    titulo: {
      type: String,
      required: false,
      default: 'Reportes',
    },
    regresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    botonRegresar() {
      const { regresar, nombreRuta } = this;

      if (regresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="scss">

</style>
